// src/utils/userLabel.js
// Display helpers for the user profile fields (first_name / last_name).
// All name fields are nullable — every existing user has them null — so these
// always fall back to email when no name is present.

/** Full display name ("First Last") when either name part is set, else email. */
export function userLabel(user) {
  if (!user) return '';
  const parts = [user.first_name, user.last_name]
    .map((s) => (typeof s === 'string' ? s.trim() : ''))
    .filter(Boolean);
  if (parts.length) return parts.join(' ');
  return user.email || '';
}

/** Single uppercase initial for avatars — from the name when present, else email. */
export function userInitial(user) {
  const label = userLabel(user);
  return (label?.[0] || '?').toUpperCase();
}
